import { cx } from '@linaria/core'

export const Container: React.FC<{
  children: React.ReactNode
  fullHeight?: boolean
}> = (props) => {
  return (
    <div
      className={cx(
        `max-w-screen-md mx-auto w-full`,
        props.fullHeight && 'h-full'
      )}
    >
      {props.children}
    </div>
  )
}

export const ContainerInset: React.FC<{
  children: React.ReactNode
  fullHeight?: boolean
}> = (props) => {
  return (
    <div className={cx('mx-4 my-5 md:mx-0', props.fullHeight && 'h-full')}>
      {props.children}
    </div>
  )
}
